module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/new.json
// module id = 747
// module chunks = 108414645950442